import { defineMessages } from 'utils/intl';

export default defineMessages({
  error:
    'Niestety metoda płatności Leaselink jest w tej chwili nie dostępna. Spróbuj ponownie później, lub wybierz inną metodę płatności.',
  leasingNotAvailable:
    'Jeden z produktów w koszyku nie może być leasingowany. Jeśli potrzebujesz więcej informacji skontaktuj się z nami.',
});
